/*
 * @Descripttion: 
 * @version: 
 * @Author: cyerogy
 * @Date: 2022-01-10 20:54:03
 * @LastEditors: cyerogy cyerogy@163.com
 * @LastEditTime: 2025-04-04 10:20:57
 */
import store from '@/store';
/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path);
}


/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validMobile(str) {
  var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
  if (!myreg.test(str)) {
    return false;
  } else {
    return true;
  }
}

/**
 * 验证邮箱的是否合法
 * @param {*} str 
 */
export function isEmail(str) {
  let myreg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.|-]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
  if (myreg.test(str)) {
    return true;
  } else {
    return false;
  }
}

export function isString(str) {
  return Object.prototype.toString.call(str) === "[object String]";
}
/**
 * Delete the left and right Spaces
 * @param str
 * @returns {string}
 */
function strTrim(str) {
  return str.replace(/(^\s*)|(\s*$)/g, "");
}
/**
 * it's a array ?
 * @param o
 * @returns {boolean}
 */
export function isArray(o) {
  return Object.prototype.toString.call(o) === '[object Array]';
}

/**
 * it's a object ?
 * @param o
 * @returns {boolean}
 */
function isObject(o) {
  return typeof o == 'object';
}
/**
 * it's a Number ?
 * @param {*} val 
 * @returns 
 */
export function isNumber(val) {
  var regPos = /^\d+(\.\d+)?$/; //非负浮点数
  var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
  if (regPos.test(val) || regNeg.test(val)) {
    return true;
  } else {
    return false;
  }
}
/**
 * it's a empty ?
 * @param {} str
 */
export function validEmpty(str) {
  if (typeof (str) == "undefined" || str == 0 || str == '' || str == '0' || str == null || str == false || str == undefined || (isString(str) && (new String(strTrim(str))).length == 0) || (isArray(str) && str.length == 0)) {
    return true;
  } else if (isObject(str)) {
    var is_empty = true;
    var prop;
    for (prop in str) {
      is_empty = false;
      break;
    }
    return is_empty;
  } else {
    return false;
  }
}

/**
 * 将数组切割成二维数组
 * @param {*} arr 
 * @param {*} newArrLength 
 * @returns 
 */
export function changeArrGroup(arr, newArrLength) {
  let changeIndex = 0;
  let secondArr = [];
  while (changeIndex < arr.length) {
    secondArr.push(arr.slice(changeIndex, changeIndex += newArrLength))
  }
  return secondArr;
}

export function deepCopy(value) {
  return JSON.parse(JSON.stringify(value));
}

export function openWindow(url, pdata) {
  if (url.startsWith("http")) {
    window.open(url);
  } else {
    let queryList = [];
    for (let key in pdata) {
      queryList.push(key + "=" + pdata[key]);
    }
    if (queryList.length == 0) {
      window.open(window.location.origin + `/#/${url}`);
    } else {
      window.open(window.location.origin + `/#/${url}?${queryList.join('&')}`);
    }
  }
}

/**
 * 权限
 * @param {*} value 
 * @returns 
 */
export function permission(value) {
  // console.log('permission', value);
  // return true;
  if (value) {
    let {
      permissionList
    } = store.state.app;
    let list = value.split(",");
    // console.log('list--', permissionList);
    let mergeArr = permissionList.filter(function (v) {
      return list.indexOf(v) !== -1; // 利用filter方法来遍历是否有相同的元素
    })
    if (mergeArr.length === 0) {
      return false;
    } else {
      return true;
    }
  } else {
    return true;
  }
}


/**
* 获取cookie的值
* @param name
* @returns {*}
*/
function cookieGet(name) {
  var cookieArray = document.cookie.split("; "); //得到分割的cookie名值对
  for (var i = 0; i < cookieArray.length; i++) {
    var arr = cookieArray[i].split("="); //将名和值分开
    //如果是指定的cookie，则它的值
    if (arr[0] == name) {
      return decodeURI(arr[1]);
    }
  }
  return "";
}

/**
 * 删除cookie
 * @param name
 */
function cookieDel(name) {
  document.cookie = name + "=; expires=" + (new Date(0)).toGMTString();
}

/**
 * 设置cookie的值
 * @param name
 * @param value
 * @param seconds 为0时不设定过期时间，浏览器关闭时cookie自动消失
 */
function cookieAdd(name, value, seconds) {
  var str = name + "=" + encodeURI(value);
  if (seconds > 0) {
    var date = new Date();
    seconds = seconds * 1000;
    date.setTime(date.getTime() + seconds);
    str += "; expires=" + date.toGMTString();
  }
  document.cookie = str + ";path=/";
}

function checkLocalStorage() {
  if (typeof window.localStorage === 'object') {
    try {
      window.localStorage.setItem('localStorage', 1);
      window.localStorage.removeItem('localStorage');
    } catch (e) {
      return false;
    }
    return true;
  } else {
    return false;
  }
}
/**
 * [setLocalStorge 设置localstorge缓存]
 * @param {[type]} name  [description]
 * @param {[string]} value [description]
 */
export function setLocalStorge(name, value) {
  if (checkLocalStorage()) {
    window.localStorage.setItem(name, value);
  } else {
    cookieAdd(name, value);
  }
}
/**
 * [getLocalStorge 获取localstorge缓存]
 * @param  {[type]} name [description]
 * @return {[type]}      [description]
 */
export function getLocalStorge(name) {
  if (checkLocalStorage()) {
    return window.localStorage.getItem(name);
  } else {
    return cookieGet(name);
  }
}
/**
 * [removeLocalStorge 清除localstorge缓存]
 * @param  {[type]} name [description]
 * @return {[type]}      [description]
 */
export function removeLocalStorge(name) {
  if (validEmpty(name)) {
    var cookieArray = document.cookie.split("; ");
    for (var i = 0; i < cookieArray.length; i++) {
      var arr = cookieArray[i].split("=");
      switch (arr[0]) {
        case 'PHPSESSID':
        case 'user_name':
        case 'password':
          break;
        default:
          cookieAdd(arr[0], null);
      }
    }
    if (typeof (window.localStorage) != "undefined") {
      if (checkLocalStorage()) {
        //window.localStorage.clear();
        var tmp = window.localStorage;
        for (var k in tmp) {
          if (['user_name', 'password'].indexOf(k) == -1) {
            localStorage.removeItem(k)
          }
        }
      }
    }
  } else {
    if (typeof (window.localStorage) != "undefined") {
      if (checkLocalStorage()) {
        window.localStorage.removeItem(name);
      } else {
        if (!validEmpty(cookieGet(name))) {
          if (name != "PHPSESSID") {
            cookieAdd(name, null);
          }
        }
      }
    } else {
      if (!validEmpty(cookieGet(name))) {
        if (name != "PHPSESSID") {
          cookieAdd(name, null);
        }
      }
    }
  }
}

export function array_sort(list, key, sort_type = "ASC") {
  let result = [];
  if (sort_type == "ASC") {
    result = list.sort(function (x, y) {
      return Number(x[key]) - Number(y[key]);
    });
  } else {
    result = list.sort(function (x, y) {
      return Number(y[key]) - Number(x[key]);
    });
  }
  return result;
}

export function echartFontSizeRem(size) {
  const clientHeight = window.innerHeight || document.documentElement.clientHeight ||
    document.body.clientHeight;
  if (!clientHeight) return;
  let fontSize = clientHeight / 1024;//尺寸大小
  return size * fontSize;
}

export function echartBarWidth(size) {
  const clientWidth = window.innerWidth || document.documentElement.clientWidth ||
    document.body.clientWidth;
  if (!clientWidth) return;
  let fontSize = clientWidth / 1920;//尺寸大小
  return size * fontSize;
}

export function findKeyByValue(obj, value) {
  return Object.keys(obj).find(key => obj[key] === value);
}

function s4() {
  return Math.floor((1 + Math.random()) * 0x10000)
    .toString(16)
    .substring(1)
}
//生成随机数
export function keyId() {
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
    s4() + '-' + s4() + s4() + s4() + '-' + (new Date()).getTime();
}


export function getLineInterSection(point1, point2, point3, point4) {
  // 计算直线 1 的参数 A1, B1, C1
  const A1 = point2[1] - point1[1];
  const B1 = point1[0] - point2[0];
  const C1 = A1 * point1[0] + B1 * point1[1];

  // 计算直线 2 的参数 A2, B2, C2
  const A2 = point4[1] - point3[1];
  const B2 = point3[0] - point4[0];
  const C2 = A2 * point3[0] + B2 * point3[1];

  // 计算分母
  const denominator = A1 * B2 - A2 * B1;

  // 判断两条直线是否平行
  if (denominator === 0) {
    return null;
  }

  // 计算交点坐标
  const x = (B2 * C1 - B1 * C2) / denominator;
  const y = (A1 * C2 - A2 * C1) / denominator;

  // 判断交点是否在线段 1 上
  const onSegment1 = (Math.min(point1[0], point2[0]) <= x && x <= Math.max(point1[0], point2[0])) &&
    (Math.min(point1[1], point2[1]) <= y && y <= Math.max(point1[1], point2[1]));

  // 判断交点是否在线段 2 上
  const onSegment2 = (Math.min(point3[0], point4[0]) <= x && x <= Math.max(point3[0], point4[0])) &&
    (Math.min(point3[1], point4[1]) <= y && y <= Math.max(point3[1], point4[1]));

  // 如果交点同时在线段 1 和线段 2 上，则返回交点坐标
  if (onSegment1 && onSegment2) {
    return [x, y];
  }

  return null;
}

export function getAngleWithXAxis(x1, y1, x2, y2) {
  // 计算斜率的分母
  const dx = x2 - x1;
  const dy = y2 - y1;

  // 处理直线垂直于 x 轴的特殊情况
  if (dx === 0) {
    return dy > 0 ? Math.PI / 2 : 3 * Math.PI / 2;
  }

  // 计算斜率
  const slope = dy / dx;

  // 计算夹角（弧度制）
  let angle = Math.atan(slope);

  // 调整夹角范围到 [0, 2π)
  if (dx < 0) {
    angle += Math.PI;
  } else if (angle < 0) {
    angle += 2 * Math.PI;
  }

  return angle;
}

export function getEndPointCoordinates(x0, y0, length, angle) {
  // 将角度转换为弧度
  const radians = angle * (Math.PI / 180);
  // 计算水平和垂直偏移量
  const deltaX = length * Math.cos(radians);
  const deltaY = length * Math.sin(radians);
  // 计算另一个端点的坐标
  const x1 = x0 + deltaX;
  const y1 = y0 + deltaY;
  return [x1, y1];
}

export function getDepthOnSegment(x1, y1, d1, x2, y2, d2, x, y) {
  // 检查点 (x, y) 是否在线段上
  const isOnSegment = (
    (Math.min(x1, x2) <= x && x <= Math.max(x1, x2)) &&
    (Math.min(y1, y2) <= y && y <= Math.max(y1, y2))
  );

  if (!isOnSegment) {
    return null; // 点不在线段上，返回 null
  }

  // 计算比例 t
  let t;
  if (x2 !== x1) {
    t = (x - x1) / (x2 - x1);
  } else if (y2 !== y1) {
    t = (y - y1) / (y2 - y1);
  } else {
    return null; // 起点和终点重合，无法计算
  }

  // 根据线性插值计算埋深
  const depth = d1 + t * (d2 - d1);
  return depth;
}

//判断一个数组是否是另外一个数组的子集
export function isSubset(arr1, arr2) {
  return arr1.every(element => arr2.includes(element));
}

//找出二维数组中最长的数组
export function findLongestArray(arr) {
  let longest = [];
  for (let i = 0; i < arr.length; i++) {
    if (arr[i].length > longest.length) {
      longest = arr[i];
    }
  }
  return longest;
}
/**
 * 已知一条线的两点坐标和平移的距离，求这条矩形的4个点坐标
 * @param {*} x1 第一个点的横坐标
 * @param {*} y1 第一个点的纵坐标
 * @param {*} x2 第二个点的横坐标
 * @param {*} y2 第二个点的纵坐标
 * @param {*} d  平移的距离
 * @returns 
 */
export function getRectangleCoordinates(x1, y1, x2, y2, d) {
  // 计算向量 AB 的分量
  const dx = x2 - x1;
  const dy = y2 - y1;
  // 计算向量 AB 的模长
  const length = Math.sqrt(dx * dx + dy * dy);
  // 计算垂直于 AB 的单位向量的分量
  const unitPerpendicularX = dy / length;
  const unitPerpendicularY = -dx / length;
  // 计算矩形的四个顶点坐标
  const pointA = [x1, y1];
  const pointB = [x2, y2];
  const pointC = [x1 + d * unitPerpendicularX, y1 + d * unitPerpendicularY];
  const pointD = [x2 + d * unitPerpendicularX, y2 + d * unitPerpendicularY];
  return [pointA, pointB, pointC, pointD];
}

// 计算线的法线向量
function getNormalVector(line, index) {
  const coordinates = line.getCoordinates();
  const dx = coordinates[index + 1][0] - coordinates[index][0];
  const dy = coordinates[index + 1][1] - coordinates[index][1];
  return [-dy, dx];
}

// 平移线
export function translateLine(line, distance) {
  const coordinates = line.getCoordinates();
  const newCoordinates = [];
  for (let i = 0; i < coordinates.length; i++) {
    let normal;
    if (i === 0) {
      normal = getNormalVector(line, i);
    } else if (i === coordinates.length - 1) {
      normal = getNormalVector(line, i - 1);
    } else {
      const normal1 = getNormalVector(line, i - 1);
      const normal2 = getNormalVector(line, i);
      normal = [normal1[0] + normal2[0], normal1[1] + normal2[1]];
    }
    const length = Math.sqrt(normal[0] * normal[0] + normal[1] * normal[1]);
    const unitNormal = [normal[0] / length, normal[1] / length];
    const x = coordinates[i][0] + unitNormal[0] * distance;
    const y = coordinates[i][1] + unitNormal[1] * distance;
    newCoordinates.push([x, y]);
  }
  return newCoordinates;
}